import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import { FILE_LIMIT } from '../../constData';
export default {
  name: 'inputFile',
  components: {},
  data() {
    return {
      list: [],
      filesFormat: ['.xlsx', '.xls']
    };
  },
  computed: {
    accept() {
      let result = this.filesFormat.join(',');
      return result;
    }
  },
  mounted() {},
  methods: {
    changefile($event) {
      let files = this.$refs.refName.files;
      console.log('upload-files', files);
      if (!files.length) return;
      let resultFiles = [];
      let sizeLimitFiles = [];
      let errorFormatFiles = [];
      for (let ele of files) {
        let lastIndex = ele.name.lastIndexOf('.');
        let suffix = ele.name.slice(lastIndex);
        if (this.filesFormat.includes(suffix)) {
          if (ele.size > FILE_LIMIT) {
            sizeLimitFiles.push(ele.name);
          } else {
            console.log('ele', ele, FILE_LIMIT);
            resultFiles.push(ele);
          }
        } else {
          errorFormatFiles.push(ele.name);
        }
      }
      if (errorFormatFiles.length) {
        console.log('errorFormatFiles', errorFormatFiles);
        ElMessage.error({
          message: errorFormatFiles.join(',') + ',文件不符合上传的格式',
          duration: 3000
        });
      }
      if (sizeLimitFiles.length) {
        console.log('sizeLimitFiles', sizeLimitFiles);
        ElMessage.error({
          message: sizeLimitFiles.join(',') + '，文件大小超过10M',
          duration: 3000
        });
      }
      this.$emit('getFiles', resultFiles);
    }
  }
};